/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { API } from '../api/api'
import { fetch, post, put } from '../api/httpClient'

export const smsSettingsCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const url = API.CORE.SMS_SETTINGS
    const { data } = await put(url, payload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const smsSettingsInfoCall = (successCallback, failureCallback) => async () => {
  try {
    const url = API.CORE.SMS_INFO
    const { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const generateOTPCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const updatedPayload = {
      mobile_prefix: payload.mobile_prefix,
      mobile_no: payload.mobile_no.replace(/-/g, ''),
      type: 'mobile',
    }
    const url = API.CORE.GENERATE_OTP
    const { data } = await post(url, updatedPayload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const verifyOTPCall = (payload, successCallback, failureCallback) => async () => {
  try {
    const updatedPayload = {
      mobile_prefix: payload.mobile_prefix,
      mobile_no: payload.mobile_no.replace(/-/g, ''),
      otp: payload.otp,
    }
    const url = API.CORE.VERIFY_OTP
    const { data } = await post(url, updatedPayload)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
